export const CodeBookFragment = gql`
  fragment CodeBookFragment on CodeBook {
    id
    name
    items {
      ...CodeBookItemFragment
    }
  }
`
